import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { User } from '../../types';

const TalentList: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSkill, setSelectedSkill] = useState<string>('all');

  // 模拟人才数据
  const mockTalents: User[] = [
    {
      id: '1',
      uuid: 'user-1',
      name: '张明',
      email: 'zhangming@example.com',
      avatar: 'https://i.pravatar.cc/40?img=14',
      bio: '资深前端开发工程师 | React专家 | 5年经验',
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    },
    {
      id: '2',
      uuid: 'user-2',
      name: '李华',
      email: 'lihua@example.com',
      avatar: 'https://i.pravatar.cc/40?img=15',
      bio: '全栈工程师 | Node.js | Python | 3年经验',
      createdAt: '2023-01-01',
      updatedAt: '2023-01-01'
    }
  ];

  const skills = [
    { id: 'all', name: '全部' },
    { id: 'frontend', name: '前端开发' },
    { id: 'backend', name: '后端开发' },
    { id: 'mobile', name: '移动开发' },
    { id: 'ai', name: '人工智能' },
    { id: 'data', name: '数据分析' }
  ];

  const filteredTalents = mockTalents.filter(talent => {
    if (selectedSkill !== 'all' && !talent.bio?.toLowerCase().includes(selectedSkill)) return false;
    if (searchQuery) {
      return talent.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
             talent.bio?.toLowerCase().includes(searchQuery.toLowerCase());
    }
    return true;
  });

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* 搜索栏 */}
      <div className="mb-8">
        <div className="relative rounded-md shadow-sm">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="block w-full rounded-md border-gray-300 pl-4 pr-12 focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
            placeholder="搜索人才..."
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path
                fillRule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>

      {/* 技能标签 */}
      <div className="mb-8">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8 overflow-x-auto">
            {skills.map((skill) => (
              <button
                key={skill.id}
                onClick={() => setSelectedSkill(skill.id)}
                className={`${
                  selectedSkill === skill.id
                    ? 'border-primary-500 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
              >
                {skill.name}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* 人才列表 */}
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {filteredTalents.map((talent) => (
          <div key={talent.id} className="bg-white shadow rounded-lg overflow-hidden">
            <div className="p-6">
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={talent.avatar}
                    alt={talent.name}
                  />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-medium text-gray-900">
                    <Link to={`/profile/${talent.id}`}>{talent.name}</Link>
                  </h3>
                  <p className="text-sm text-gray-500">{talent.bio}</p>
                </div>
              </div>
              <div className="mt-4 flex justify-end">
                <Link
                  to={`/profile/${talent.id}`}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
                >
                  查看详情
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 发布简历按钮 */}
      <div className="fixed right-8">
        <Link
          to="/profile/edit"
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          <svg
            className="-ml-1 mr-2 h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          发布简历
        </Link>
      </div>
    </div>
  );
};

export default TalentList; 